import gql from 'graphql-tag';

export class DirectoryFragments {
  static directoryFragment = gql`
    fragment directoryFragment on Resource {
      id
      directory
      title
    }
  `;
}
